import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { Column } from '../interfaces/column.interface';
import { Tree } from 'primeng/tree';

@Injectable({
  providedIn: 'root'
})
export class TermsColumnsService {


  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
  ) {
  }
 
  getColumns(): Column[] {
    return [
     // { field: 'id', sortField: 'id', title: this.translate.instant('ID'), show: (this.navigation.getParamValue('posts.id.showFiled', true) && true), displayInList: true, type: 'numericValue' },
      { field: 'content', sortField: 'content', title: this.translate.instant('CONTENT.CONTENT'), show: (this.navigation.getParamValue('terms.content.showFiled', true) && true), displayInList: true, type: 'textValue' },
      { field: 'actions', title: this.translate.instant('CONTENT.ACTIONS'), type: 'static', show: true, displayInList: true, sortField: null },
      { field: 'applicationName', sortField: 'applicationName', title: this.translate.instant('applicationName'), show: (this.navigation.getParamValue('terms.applicationName.showFiled', true) && true), displayInList: true, type: 'textValue'},

    ];
  }

}
